<template>
    <d-container fluid class="main-content-container px-4">
        <div class="page-header row no-gutters py-4">
            <div class="col-12 text-center text-sm-left mb-0">
                <h3 class="page-title">Connect Integration</h3>
            </div>
        </div>

        <d-card class="mt-3 mb-3">
            <d-card-header class="border-bottom">
                <d-row class="d-flex justify-content-center">
                    <d-col cols="2" class="progress-text d-none d-xl-block">
                        <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-domain' }">1. Add website</d-link></h6>
                    </d-col>
                    <d-col cols="2" class="progress-text d-none d-xl-block">
                        <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-network' }">2. Connect networks</d-link></h6>
                    </d-col>
                    <d-col cols="2" class="progress-text d-none d-xl-block">
                        <h6 class="m-0 text-center bar-text"><d-link class="text-dark" :to="{ name: 'add-intergration' }"><u>3. Connect integrations</u></d-link></h6>
                    </d-col>
                    <d-col cols="2" class="progress-text d-none d-xl-block">
                        <h6 class="m-0 text-center bar-text">4. Place Ivanhoe.io tag</h6>
                    </d-col>
                    <d-col cols="2" class="progress-text d-none d-xl-block">
                        <h6 class="m-0 text-center bar-text">5. Choose direct or cloaked links</h6>
                    </d-col>
                    <d-col cols="2" class="progress-text pl-0 pr-0 d-none d-xl-block">
                        <h6 class="m-0 text-center bar-text">6. Ready to start</h6>
                    </d-col>
                </d-row>
                <d-progress :value="percent" :max="100" />
            </d-card-header>
            <d-card-body>
                <d-row class="mt-3">
                    <d-col class="mb-4" lg="4" v-if="googleAnalytics && googleAnalyticsIsReady">
                        <ga :config="googleAnalytics" :hasGoogleConnection="hasGoogleConnection" />
                    </d-col>
                    <d-col class="mb-4" lg="4">
                        <gaV4 :config="googleAnalyticsV4" :redirect="this.$route.fullPath" />
                    </d-col>
                    <d-col class="mb-4" lg="4">
                        <ba :bing-ads="bingAds" />
                    </d-col>
                    <d-col class="mb-4" lg="4">
                        <facebook-integration :facebook="facebook" />
                    </d-col>
                </d-row>
            </d-card-body>
            <d-card-footer>
                <d-row>
                    <d-col class="d-flex justify-content-start">
                        <d-link tag="button" :to="{ name: 'add-network' }" class="btn btn-secondary">Previous step</d-link>
                    </d-col>
                    <d-col class="d-flex justify-content-end">
                        <d-link tag="button" :to="{ name: 'snippet', params: { id: websiteId } }" class="btn btn-success">Next step</d-link>
                    </d-col>
                </d-row>
            </d-card-footer>
        </d-card>
    </d-container>
</template>

<script>
    import BingAds from '@/views/integrations/bing-ads/connect.vue';
    import GoogleAnalytics from '@/views/integrations/google-analytics/connect.vue';
    import facebookIntegration from '@/views/integrations/facebook/connect.vue';
    import { GaService, WebsiteService } from '@/main';
    import permissions from '../../../mixins/permissions';
    import GoogleAnalyticsV4 from "@/components/integrations/google-analytics-v4/Component.vue";

    export default {
        mixins: [permissions],
        components: {
            gaV4: GoogleAnalyticsV4,
            ga: GoogleAnalytics,
            ba: BingAds,
            facebookIntegration
        },

        data() {
            return {
                websiteId: this.$route.params.id,
                percent: 40,
                googleAnalytics: null,
                googleAnalyticsV4: null,
                googleOAuth: null,
                bingAds: null,
                facebook: null,
                hasGoogleConnection: null,
                googleAnalyticsIsReady: false,
            };
        },

        methods: {
            async getWebsite() {
                try {
                    const website = await WebsiteService.getById(this.$route.params.id)
                    this.googleAnalytics = website.googleAnalyticsIntegration
                    this.bingAds = website.bingAdsIntegration
                    this.facebook = website.facebookIntegration
                    this.googleAnalyticsV4 = website.googleAnalyticsV4Integration;
                    this.bingAds = website.bingAdsIntegration;
                    this.facebook = website.facebookIntegration;
                    this.hasGoogleConnection = website.hasGoogleConnection;
                    this.googleAnalyticsIsReady = true;
                    console.log('rr', this.$route.fullPath)
                } catch(e) {
                    console.log(e)
                    return false
                }
            },
        },

        created () {
            this.getWebsite()
        },
    };
</script>
